import { render } from "./RandomQuestion.vue?vue&type=template&id=2f90cefc&scoped=true"
import script from "./RandomQuestion.vue?vue&type=script&lang=js"
export * from "./RandomQuestion.vue?vue&type=script&lang=js"

import "./RandomQuestion.vue?vue&type=style&index=0&id=2f90cefc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f90cefc"]])

export default __exports__